import { Exposure, ExposureTrackingProvider } from '@amplitude/experiment-js-client';
import { trackForDestination } from '../../utils/external-libs/segment';

class SegmentExposureTrackingProvider implements ExposureTrackingProvider {
  track(exposure: Exposure) {
    trackForDestination('Amplitude', '$exposure', exposure);
  }
}

export default SegmentExposureTrackingProvider;
